import { useQuery } from "react-query";
import { isEmpty } from "../../lib/helpers/helpers";
import { fetchShopItems } from "../actions/shop";

export const useFetchShopItems = ({ weddingID }) => {
	return useQuery(
		["shopItems", { weddingID }],
		() => fetchShopItems({ weddingID }),
		{
			enabled: !isEmpty(weddingID),
		}
	);
};

// export const usePostAction = () => {
// 	return useMutation(reactToWeddingPost);
// };
